import { Store } from '../../types';

export const STORES: Store[] = [
  {
    id: 3,
    name: 'Main Restaurant',
    deparmentId: 8,
    cameras: [
      {
        id: 21,
        es_cam_id: 'cam3',
      },
      {
        id: 22,
        es_cam_id: 'cam4',
      },
      {
        id: 23,
        es_cam_id: 'cam2',
      },
      {
        id: 24,
        es_cam_id: 'cam1',
      },
    ],
  },
  {
    id: 4,
    name: 'Market',
    deparmentId: 9,
    cameras: [
      {
        id: 25,
        es_cam_id: 'cam3',
      },
      {
        id: 26,
        es_cam_id: 'cam2',
      },
      {
        id: 29,
        es_cam_id: 'cam1',
      },
      {
        id: 30,
        es_cam_id: 'cam4',
      },
    ],
  },
];
